import React, { Component } from 'react';
import axios from 'axios';
import { API_PATH2} from './config.js';

class DayOff extends Component {

    constructor (props) {
        super(props)
        this.state = {
          loading: true,
          data:[],
        }
    }

    componentDidMount() {
        setTimeout(() => {
            this.fetchDayOff();
        }, 100);
    }

    fetchDayOff = () => {
        axios.get(API_PATH2 + "dayoff?page=1&per_page=100")
        .then(response => {
            const data = response.data;
            this.setState({ data, loading: false });
        })
        .catch(error => {
            console.error('Error fetching data:', error);
        });
    }

    Sanitize(title) {
        var rawMarkup = title;
        return { __html: rawMarkup };
    }

    setHeaders = () => {
        var mig0 = "Inicio";
        var mig1 = "Beneficios";   
        var mig2 = "Convenios";
        var mig3 = "DayOff";
        return (
            <div >
                <div className="breadcrumbs">
                {/* <span><label>{mig0}&nbsp;<i className="fa fa-angle-right"></i> {mig1}&nbsp;<i className="fa fa-angle-right"></i> {mig2}&nbsp;<i className="fa fa-angle-right"></i> {mig3}</label>
                    </span> */}
                </div>
                <h1 align="center" className="tituloPrincipal"><b> {mig3}</b></h1>
                <hr className="hrb5" />
            </div>
        )
    }

    render() {
       const { loading, data } = this.state;
        if (loading === true) {
            return(
                <div className="preloader" >
                    <div className="div-transform">
                        <div className="loader">
                            <div className="face">
                                <div className="circle"></div>
                            </div>
                            <div className="face">
                                <div className="circle"></div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }
        return (
            
            <div className="container">
                {this.setHeaders()}
                <div className='row'>
                        {data.map((Fmt, index) => {
                            var contenidoParse;
                            var contenido = Fmt.content.rendered;
                            var res = contenido.replace(new RegExp("<p>", 'g'), "");
                            res = res.replace(new RegExp("</p>", 'g'), "");
                            contenidoParse = res.replace(new RegExp("<a", 'g'), "<a class='aUnderline'");
                            return (
                                <div  key={index}>
                                    <div className="row">
                                        <div className="col-md-12 texto-centro" >
                                            <a href={Fmt.acf.format_file} target="_blank">
                                            <h3 className="message-news" dangerouslySetInnerHTML={this.Sanitize(Fmt.title.rendered)}></h3>
                                            </a>
                                            <div className="pjus" dangerouslySetInnerHTML={this.Sanitize(contenidoParse)}>
                                            </div>
                                        </div>
                                    </div>
                                    <hr className="hr-sweet" />
                            </div>
                            )
                        })}
                    </div>
            </div>
            
        )
    }
}

export default (DayOff);